module.exports = function() {
  return new Worker(__webpack_public_path__ + "44372148ee11f515a71d.worker.js");
};